module.exports = __webpack_public_path__ + "static/media/tractor-128.5c06e8d1.png";